import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { timeIntervalRule } from './rule';
import { timeInterval, restTime } from '../enmu';
export default {
  props: {
    ruleKey: {
      type: String,
      default: ''
    },
    // 数据源
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 时段的时间格式
    timeOption: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      // 时段校验
      timeIntervalRule: timeIntervalRule,
      // 工作日是否处于编辑状态
      weekdayEditingStatus: true,
      // 可选加班日期至少选中一项
      validatePass: function validatePass(rule, value, callback) {
        return _this.isAllow ? callback() : callback(new Error(_this.$t('1812')));
      },
      // 可选申请日期校验
      validateDate: function validateDate(rule, value, callback) {
        if (!value) return callback(new Error(_this.$t('221')));
        var state = _this.form.start === _this.form.end;
        return !state ? callback() : callback(new Error(_this.$t('1815')));
      }
    };
  },
  computed: {
    isAllow: function isAllow() {
      var _this$form = this.form,
        is_allow_apply_date_forward = _this$form.is_allow_apply_date_forward,
        is_allow_apply_date_backward = _this$form.is_allow_apply_date_backward,
        allow_apply_date_this_day = _this$form.allow_apply_date_this_day;
      var state = [is_allow_apply_date_forward, is_allow_apply_date_backward, allow_apply_date_this_day].some(function (item) {
        return item;
      });
      return state;
    },
    isShowNextDay: function isShowNextDay() {
      var _this$form2 = this.form,
        start = _this$form2.start,
        end = _this$form2.end;
      if (!start || !end) return false;
      var startArr = start.split(':');
      var endArr = end.split(':');
      var startTime = new Date(2020, 0, 0, 0, startArr[0], startArr[1]);
      var endTime = new Date(2020, 0, 0, 0, endArr[0], endArr[1]);
      if (startTime > endTime) return true;
      return false;
    }
  },
  methods: {
    handlerInput: function handlerInput(e, params) {
      if (!e) return false;
      var value = e.target.value;
      var min = params.min,
        max = params.max;
      if (min && value < min) e.target.value = min;
      if (max && value > max) e.target.value = max;
    },
    /**
     *  时段添加删除
     *  @param { Number } index 当前下标
     *  @param { Boolean } bool 判断操作的目标对象
     *  @param { String } type 添加或删除 add or remove
     */
    handlerAddTimeInterval: function handlerAddTimeInterval(index, bool, type) {
      var editKey = bool ? 'rest_time_rule' : 'rest_time_period_formate';
      var exampleObj = bool ? restTime() : timeInterval();
      type === 'add' ? this.form[editKey].splice(index + 1, 0, exampleObj) : this.form[editKey].splice(index, 1);
      this.updateData();
    },
    // 数据源更新
    updateData: function updateData() {
      this.$emit('changeData', this.ruleKey, JSON.parse(JSON.stringify(this.form)));
    },
    // 类型名称编辑
    handlerEditTypeName: function handlerEditTypeName() {
      var _this2 = this;
      this.weekdayEditingStatus = !this.weekdayEditingStatus;
      // 主动获取焦点
      if (!this.weekdayEditingStatus) this.$nextTick(function () {
        return _this2.$refs.typeName.focus();
      });
    },
    // 生成校验key
    formateKey: function formateKey(str) {
      return 'settings.' + this.ruleKey + '.' + str;
    }
  }
};